import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

const KEY = "tulsi:scroll";
const read = () => { try { return JSON.parse(sessionStorage.getItem(KEY) || "{}"); } catch { return {}; } };

// Restores window scroll position when navigating Back/Forward; scrolls to top on new pages.
export default function ScrollMemory() {
  const location = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    const save = () => {
      const all = read(); all[location.key] = window.scrollY;
      try { sessionStorage.setItem(KEY, JSON.stringify(all)); } catch {}
    };
    window.addEventListener("scroll", save, { passive: true });
    return () => { save(); window.removeEventListener("scroll", save); };
  }, [location.key]);

  useEffect(() => {
    if (navType === "POP") {
      const y = read()[location.key] || 0;
      const t1 = setTimeout(() => window.scrollTo(0, y), 60);
      const t2 = setTimeout(() => window.scrollTo(0, y), 400);
      return () => { clearTimeout(t1); clearTimeout(t2); };
    }
    window.scrollTo(0, 0);
  }, [location.key, navType]);

  return null;
}
